import { render } from "./NominationWonCheckbox.vue?vue&type=template&id=356ea34b&scoped=true"
import script from "./NominationWonCheckbox.vue?vue&type=script&lang=js"
export * from "./NominationWonCheckbox.vue?vue&type=script&lang=js"

import "./NominationWonCheckbox.vue?vue&type=style&index=0&id=356ea34b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356ea34b"]])

export default __exports__